"use client";

import dynamic from "next/dynamic";

const DatadogInit = dynamic(
	() => import("@/app/_components/DatadogInit"),
	// Don't include this in static generation, as it leads to the build timing out
	{ssr: false}
);

/**
 * Load frontend observability dynamically, so it never gets pre-built
 */
const FrontendObservabilityDynamicWrapper = () => {
	if (!process.env.NEXT_PUBLIC_ENABLE_DATADOG_RUM) {
		return null;
	}

	return <DatadogInit />;
};

export default FrontendObservabilityDynamicWrapper;
